import { Section } from "@jesus-central-church/ui";
import {
  SbBlokData,
  storyblokEditable,
  StoryblokServerComponent,
} from "@storyblok/react/rsc";
import { SbSection } from "@storyblok/types/287435740670216/storyblok-components";

export function SectionComponent({
  blok,
  pageData,
}: {
  blok: SbSection;
  pageData: { locale: string };
}) {
  return (
    <Section
      backgroundColor={(blok.backgroundColor as string) ?? "freedom"}
      {...storyblokEditable(blok as SbBlokData)}
    >
      {/* No extra container wrapper - Section already handles container */}
      {blok.block?.map((nestedBlok) => (
        <StoryblokServerComponent
          key={nestedBlok._uid}
          blok={nestedBlok}
          pageData={pageData}
        />
      ))}
    </Section>
  );
}
